import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 50px;
  color: #d9d9d9;
`;

const UploadIcon: React.FC = () => {
  return (
    <Container>
      <i className="fa fa-cloud-upload" aria-hidden="true"></i>
    </Container>
  );
};

export default UploadIcon;
